import { Model } from '@/models/Model';

export class AttributeValue extends Model
{
  protected $name: string = 'AttributeOption';
  protected $endpoint: string = '/attribute-values';
  protected $fillable: string[] = ['value', 'attribute', 'product_variant'];

  public value?: string;
  public id?: string;
  public attribute?: string;
  public product_variant?: string;
}
